import { graphql } from '../gql';

export const SEND_RENEWAL_EMAIL = graphql(`
  mutation sendRenewalEmail($uuid: UUID!, $token: String!) {
    sendRenewalEmail(uuid: $uuid, token: $token) {
      ok
    }
  }
`);
